import api from "../../../api/api";

/* =========================
   LISTING
========================= */
interface EmployeeFilters {
  id?: string;
  first_name?: string;
  last_name?: string;
  mobile?: string;
  role?: string;
  vertical?:string;
  is_active?: string;
  ordering?: string;
  page_size?: number | string;
}

export const getEmployeeProfiles = (
  page: number,
  filters?: EmployeeFilters
) => {
  const params = new URLSearchParams();
  params.append("page", String(page));

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, String(value));
      }
    });
  }

  return api.get(`/hr/v1/create-user-profile/?${params.toString()}`);
};

/* =========================
   MASTER APIs
========================= */
export const getVerticals = () => {
  return api.get("/hr/v1/verticals/");
};

export const getLocationsByVertical = (verticalId: number) => {
  return api.get(`/hr/v1/locations/?vertical_id=${verticalId}`);
};

export const getDepartments = () => {
  return api.get("/crm/v1/department/");
};

export const getRoles = () => {
  return api.get("/company/v1/get-role-permission/");
};

export const getDesignations = () => {
  return api.get("/hr/v1/designation/");
};

export const getReportingManagers = (params: {
    vertical_ids?: number[];
    role?: string;
    location_ids?: number[];
}) => {
    return api.get("/hr/v1/reporting-managers/", {
        params,
        paramsSerializer: params => {
            const search = new URLSearchParams();

            /* vertical_ids */
            if (params.vertical_ids && params.vertical_ids.length) {
                params.vertical_ids.forEach((v: number) =>
                    search.append("vertical_ids", String(v))
                );
            } else {
                search.append("vertical_ids", "");   // ⭐ REQUIRED
            }

            /* location_ids */
            if (params.location_ids && params.location_ids.length) {
                params.location_ids.forEach((l: number) =>
                    search.append("location_ids", String(l))
                );
            } else {
                search.append("location_ids", "");   // ⭐ REQUIRED
            }

            /* role */
            if (params.role) {
                search.append("role", params.role);
            }

            return search.toString();
        },
    });
};



/* =========================
   CREATE APIs (USE employee_id)
========================= */
export const createCompanyUser = (payload: {
  username: string;
  email: string;
  password: string;
  confirm_password: string;
  user_role: any[];
  user_permissions: any[];
}) => {
  return api.post("/company/v1/create-company-user/", payload);
};
export const updateCompanyUser = (id: number, payload: any) => {
    return api.put(`/company/v1/create-company-user/${id}/`, payload);
};


export const createUserProfile = (payload: {
  user: number;    
  first_name: string;
  middle_name?: string;
  last_name: string;
  aadhar_no?: string;
  pan_no?: string;
  gender_type?: string;
  dob?: string;
  joining_date?: string;
  leaving_date?: string | null;
  mobile?: string;
  personal_email_id?: string;
  official_mail_id?: string;
  current_address?: string;
  permanent_address?: string;
  is_active?: string;
}) => {
  return api.post("/hr/v1/create-user-profile/", payload);
};

export const assignEmployeeVerticalLocation = (payload: {
  employee_id: number;
  vertical_locations: {
    vertical_id: number;
    location_ids: number[];
  }[];
}) => {
  return api.post("/hr/v1/employee-vertical-location/", payload);
};

export const assignEmployeeDepartment = (payload: {
  employee_id: number;
  department_id: number | null;
}) => {
  return api.post("/hr/v1/employee-department/", payload);
};

export const assignEmployeeDesignation = (payload: {
  employee_id: number;
  designation_id: number | null;
  assign_reporting: number | null;
  sales_target?: string;
}) => {
  return api.post("/hr/v1/employee-designation/", payload);
};

/* =========================
   VIEW / EDIT APIs (USE user_id)
========================= */

/**
 * 🔹 Profile by USER ID
 * GET /hr/v1/create-user-profile/{user_id}
 */
export const getUserProfileById = (userId: number) => {
  return api.get(`/hr/v1/create-user-profile/${userId}/`);
};

export const getCompanyUserById = (userId: number) => {
  return api.get(`/company/v1/create-company-user/${userId}`);
};


/**
 * 🔹 Vertical + Location by USER ID
 * GET /hr/v1/employee-vertical-location/?user_id={userId}
 */
export const getEmployeeVerticalLocationByUserId = (userId: number) => {
  return api.get(`/hr/v1/employee-vertical-location/?user_id=${userId}`);
};

/**
 * 🔹 Designation + Role + Reporting Manager by USER ID
 * GET /hr/v1/employee-designation/?user_id={userId}
 */
export const getEmployeeDesignationByUserId = (userId: number) => {
  return api.get(`/hr/v1/employee-designation/?user_id=${userId}`);
};

/**
 * 🔹 Department by DESIGNATION ID (⚠️ backend quirk)
 * GET /hr/v1/employee-department/?user_id={designationId}
 */
export const getEmployeeDepartmentByDesignationId = (designationId: number) => {
  return api.get(`/hr/v1/employee-department/?user_id=${designationId}`);
};

/**
 * 🔹 Update profile by USER ID
 */
export const updateEmployeeProfile = (userId: number, payload: any) => {
  return api.put(`/hr/v1/create-user-profile/${userId}/`, payload);
};
export const getHRRoles = () => {
  return api.get("/hr/v1/roles/");
};
export const assignRolesToUser = (payload: {
  user_id: number;
  role: string;
}) => {
  return api.post("/hr/v1/assign-roles/", payload);
};
export const getEmployeeCount = () => {
  return api.get("/hr/v1/employee-count/");
};
